import KonverzacijeGridProvider from './KonverzacijeGridProvider';
// import GridProvider from './GridProvider';
// import { useState } from 'react';
// import { Box, Tab, Tabs } from '@mui/material';
// import { a11yProps, TabPanel } from '../../../../../UI/MuiTab';

const TabsProvider = ({
  // pregledTestiranja,
  konverzacijeTestiranja,
  // pregledLoading,
  konverzacijeLoading,
  // handleClickNapomena,
  idMasineTest,
}) => {
  return (
    <>
      {/* Pregled testiranja tab — privremeno isključen
      <Box sx={{ width: '98%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs ...>
            <Tab label="Pregled testiranja" ... />
            <Tab label="Konverzacije testiranja" ... />
          </Tabs>
        </Box>
      </Box>
      <TabPanel disabled value={value} index={0}>
        <GridProvider ... />
      </TabPanel>
      */}
      <KonverzacijeGridProvider
        data={konverzacijeTestiranja}
        isLoading={konverzacijeLoading}
        idMasineTest={idMasineTest}
      />
    </>
  );
};

export default TabsProvider;
